import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { Activity } from "@mapmycustomers/shared/types/entity";
import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import NoteCompletionCardData from "@app/scene/dashboard/store/cards/noteCompletion/NoteCompletionCardData";
import { DrillDownListFetcherPayload } from "@app/scene/dashboard/types/DrillDownListFetcher";
import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import NoteCompletionCardConfiguration from "@app/types/dashboard/cards/noteCompletion/NoteCompletionCardConfiguration";
import DashboardCard from "@app/types/dashboard/DashboardCard";
import Scope from "@app/types/dashboard/Scope";

export const fetchNoteCompletionCardData = createAction("@dashboard/fetchNoteCompletionCardData")<{
  callback: (data: NoteCompletionCardData) => void;
  cardId: DashboardCard["id"];
  configuration: NoteCompletionCardConfiguration;
  failureCallback?: () => void;
  scope?: Scope;
}>();

export const showNoteCompletionDrillDown = createAsyncAction(
  "@dashboard/showNoteCompletionCardDrillDownModal/request",
  "@dashboard/showNoteCompletionCardDrillDownModal/success",
  "@dashboard/showNoteCompletionCardDrillDownModal/failure"
)<
  {
    configuration: NoteCompletionCardConfiguration;
    customDateRange?: DateRange;
    scope: Scope;
  },
  { viewState: DrillDownViewState },
  unknown
>();

export const hideNoteCompletionDrillDown = createAction(
  "@dashboard/hideNoteCompletionCardDrillDownModal"
)<void>();

export const fetchNoteCompletionCardDrillDownData = createAsyncAction(
  "@dashboard/fetchNoteCompletionCardDrillDownData/request",
  "@dashboard/fetchNoteCompletionCardDrillDownData/success",
  "@dashboard/fetchNoteCompletionCardDrillDownData/failure"
)<
  DrillDownListFetcherPayload<Activity>,
  {
    totalFilteredRecords: number;
    totalRecords: number;
  },
  unknown
>();

export const applyNoteCompletionDrillDownListViewSettings = createAction(
  "@dashboard/applyNoteCompletionDrillDownListViewSettings"
)<Partial<DrillDownViewState>>();

export const exportNoteCompletionCardDrillDownData = createAction(
  "@dashboard/exportNoteCompletionCardData"
)<{
  configuration: NoteCompletionCardConfiguration;
  scope: Scope;
}>();

export type NoteCompletionCardActions = ActionType<
  | typeof applyNoteCompletionDrillDownListViewSettings
  | typeof exportNoteCompletionCardDrillDownData
  | typeof fetchNoteCompletionCardData
  | typeof fetchNoteCompletionCardDrillDownData
  | typeof hideNoteCompletionDrillDown
  | typeof showNoteCompletionDrillDown
>;
